import React, { Component } from "react";
import { v4 as uuid } from "uuid";

/**
 * @class
 * @classdesc Info tooltip button inside controls.
 *
 * @param {object} props - Control properties.
 * @param {string} contentHtml - Text or HTML content being displayed in tooltip.
 */
export default class HcsInfoButton extends Component {
	constructor(props) {
		super(props);

		this.dataTipUid = "dt-" + uuid();
	}

	render() {
		return(
			<>
				<a
					className="hcs-info-button"
					data-tip={this.dataTipUid}
					data-event="click"
				>
					<svg icon-id="icn-029-2-info" version="2.0">
						<use href="#icn-029-2-info"></use>
					</svg>
				</a>
				<div className="hcs-info-button-preloader" dangerouslySetInnerHTML={{ __html: this.props.contentHtml }}></div>
			</>);
	}
}